<template>
	<div>
		<div class="month">      
			<ul>
				<li>
					{{ month }}<br>
					<span style="font-size:18px">{{ year }}</span>
				</li>
			</ul>
		</div>
		<ul class="weekdays">
			<li>Mo</li>
			<li>Tu</li>
			<li>We</li>
			<li>Th</li>
			<li>Fr</li>
			<li>Sa</li>
			<li>Su</li>
		</ul>
		<ul class="days">  
			<li><span :id="createIdForCalendarDays(1)">1</span></li>
			<li><span :id="createIdForCalendarDays(2)">2</span></li>
			<li><span :id="createIdForCalendarDays(3)">3</span></li>
			<li><span :id="createIdForCalendarDays(4)">4</span></li>
			<li><span :id="createIdForCalendarDays(5)">5</span></li>
			<li><span :id="createIdForCalendarDays(6)">6</span></li>
			<li><span :id="createIdForCalendarDays(7)">7</span></li>
			<li><span :id="createIdForCalendarDays(8)">8</span></li>
			<li><span :id="createIdForCalendarDays(9)">9</span></li>
			<li><span :id="createIdForCalendarDays(10)">10</span></li>
			<li><span :id="createIdForCalendarDays(11)">11</span></li>
			<li><span :id="createIdForCalendarDays(12)">12</span></li>
			<li><span :id="createIdForCalendarDays(13)">13</span></li>
			<li><span :id="createIdForCalendarDays(14)">14</span></li>
			<li><span :id="createIdForCalendarDays(15)">15</span></li>
			<li><span :id="createIdForCalendarDays(16)">16</span></li>
			<li><span :id="createIdForCalendarDays(17)">17</span></li>
			<li><span :id="createIdForCalendarDays(18)">18</span></li>
			<li><span :id="createIdForCalendarDays(19)">19</span></li>
			<li><span :id="createIdForCalendarDays(20)">20</span></li>
			<li><span :id="createIdForCalendarDays(21)">21</span></li>
			<li><span :id="createIdForCalendarDays(22)">22</span></li>
			<li><span :id="createIdForCalendarDays(23)">23</span></li>
			<li><span :id="createIdForCalendarDays(24)">24</span></li>
			<li><span :id="createIdForCalendarDays(25)">25</span></li>
			<li><span :id="createIdForCalendarDays(26)">26</span></li>
			<li><span :id="createIdForCalendarDays(27)">27</span></li>
			<li><span :id="createIdForCalendarDays(28)">28</span></li>
			<li><span :id="createIdForCalendarDays(29)">29</span></li>
			<li><span :id="createIdForCalendarDays(30)">30</span></li>
			<li><span :id="createIdForCalendarDays(31)">31</span></li>
		</ul>
	</div>
</template>

<script>

export default {
	name: "Calendar",
	props: {
		cycleData: Object
	},
	data() {
		return {
			month: null,
			year: null
		};
					
	},
	created() {
		if(this.cycleData.length != 0) {
			this.getMonthAndYear();
		}			
	},
	mounted() {
		this.setScheduleDates();
	},

	methods: {
		getMonthAndYear() {
			this.month = new Date(this.cycleData[0].cycleStart).toLocaleString('default', {month: 'long'});
			this.year = new Date(this.cycleData[0].cycleStart).getFullYear();
			console.log("this is the month", this.month);
			console.log("this is the year", this.year);
		},

		createIdForCalendarDays(day){
			let calendarDayWithMonthAndYear = `day-${day}-${this.month}-${this.year}`;
			return calendarDayWithMonthAndYear;
		},

		setScheduleDates() {
			if(this.cycleData.length == 0) return;
			
			let startDateWithoutOffest = new Date(this.cycleData[0].windows[0].windowStart);
			let endDateWithoutOffest = new Date(this.cycleData[0].windows[0].windowEnd);
			let startDate = new Date(startDateWithoutOffest).getDate();
			let endDate = new Date(endDateWithoutOffest).getDate();

			for (let day = startDate; day <= endDate; day++){

				document.getElementById(this.createIdForCalendarDays(day)).classList.add("active");
				//console.log("this is the element", document.getElementById(this.createIdForCalendarDays(day)));
			}
		}
	}
}

</script>
<style scoped>
* {box-sizing: border-box;}
ul {list-style-type: none;}
body {font-family: Verdana, sans-serif;}

.month {
	padding: 70px 25px;
	width: 95%;
	background: #5b88c0;
	text-align: center;
}

.month ul {
	margin: 0;
	padding: 0;
}

.month ul li {
	color: white;
	font-size: 20px;
	text-transform: uppercase;
	letter-spacing: 3px;
}

.month .prev {
	float: left;
	padding-top: 10px;
}

.month .next {
	float: right;
	padding-top: 10px;
}

.weekdays {
	margin: 0;
	padding: 10px 0;
	background-color: #ddd;
	width: 95%;
}

.weekdays li {
	display: inline-block;
	width: 13.6%;
	color: #666;
	text-align: center;
}

.days {
	padding: 10px 0;
	background: #eee;
	margin: 0;
	width: 95%;
}

.days li {
	list-style-type: none;
	display: inline-block;
	width: 13.6%;
	text-align: center;
	margin-bottom: 5px;
	font-size:12px;
	color: #777;
}

.days li .active {
	padding: 5px;
	background: #5b88c0;
	color: white !important
}

</style>